export default {
  error (state) {
    return state.error
  },
  loading (state) {
    return state.loading
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js